import { errorHandler } from "@/services/toastHandler";

const initState = () => ({
  loading: false,
  deposits: [],
  pagination: {
    page: 1,
    limit: 10,
    total: -1,
  },
});

export default {
  namespaced: true,
  state: initState(),
  mutations: {
    SET_LOADING: (s, data) => (s.loading = data),
    SET_DEPOSITS: (s, data) => {
      s.deposits = data.deposits;
      s.pagination = data.pagination;
    },
    RESET: (s) => Object.assign(s, initState()),
  },

  actions: {
    async getDeposits({ commit }, params) {
      commit("SET_LOADING", true);
      try {
        const res = await this.$api.get("/v1/portal/transactions", { params });
        const { data, pagination } = res.data;
        commit("SET_DEPOSITS", {
          deposits: data,
          pagination,
        });
        return data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("SET_LOADING", false);
      }
    },
  },
};
